
import Vue from 'vue'
import moment from 'moment'
import { downloadFile } from '@/utils'

const paramsTransformer = ({ searchedWord, camp, dateFrom, dateTo }) => {
  const from = dateFrom ? moment(dateFrom).format('YYYY-MM-DD') : null
  const to = dateTo ? moment(dateTo).format('YYYY-MM-DD') : null

  return {
    searched_word: searchedWord || undefined,
    camp: camp > 0 ? camp : undefined,
    date_from: from,
    date_to: to,
  }
}

export default (params = {}) => {
  const queryParams = paramsTransformer(params)
  const { date_to: dTo, date_from: dFrom } = queryParams
  const filename = `reporte_compras${dFrom ? '_' : ''}${dFrom || ''}${dTo ? '_' : ''}${dTo || ''}.xls`
  return downloadFile('purchase/purchase_order_report/', filename, {
    config: {
      params: queryParams
    },
  })
}


// WEBPACK FOOTER //
// ./src/services/purchase/fetchPurchaseReport.js